import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loaderLoaded: false,
    coreDataLoaded: false,
    viewDataLoaded: false,
    viewLoaded: false,
    viewReady: false,
    menuOpen: false,
    introShown: false,
    showIntro: false,
    modalOpen: false,
    menuButton: false,
    introSkip: true,
    disableParallax: false,
    lightboxData: false,
    scrollBarWidth: '0px',
    currentScrollBarWidth: '0px',
    data: {
      POSTS: {},
    },
    storiesCache: {},
    stories: [],
    singleStory: null,
    isSingleStoryRoute: false,
    storiesPerPage: 10,
    totalStories: 0,
    loading: false,
    error: null,
    currentPage: 1,
  },
  getters: {
    getChapterPartBasics(state) {
      return state.data.OUTLINE.data.chapters.map((chapter) => {
        return {
          parts: chapter.parts,
          title: chapter.title,
          roman: chapter.roman,
          main: chapter.images.main.replace('chapters/', 'chapters/small/'),
          slug: chapter.id,
        }
      })
    },
    getChapterLinks(state) {
      return state.data.OUTLINE.data.chapters.map((chapter) => {
        return {
          parts: chapter.parts,
          slug: chapter.id,
          title: chapter.title,
          externalUrl: chapter.external_chapter ? chapter.external_chapter_link : null,
          main: chapter.images.main.replace('chapters/', 'chapters/small/'),
          background: chapter.images.background.replace('chapters/', 'chapters/small/'),
          roman: chapter.roman,
        }
      })
    },
    getPosts(state) {
      return state.data.POSTS
    },
    allStories: (state) => state.stories,
    singleStory: (state) => state.singleStory,
    storiesLoading: (state) => state.loading,
    storiesError: (state) => state.error,
    totalNumberOfStories: (state) => state.totalStories,
    numberOfPages: (state) => Math.ceil(state.totalStories / state.storiesPerPage),
    getCurrentPage: (state) => state.currentPage,
    isSingleStoryRoute: (state) => {
      return state.isSingleStoryRoute
    },
  },
  mutations: {
    TOGGLE(state, payload) {
      state[payload.type] = payload.status
    },
    SET_DATA(state, payload) {
      state.data[payload.type] = payload
    },
    TOGGLE_MENU(state) {
      state.menuOpen = !state.menuOpen
    },
    SET_POSTS(state, payload) {
      if (!state.data.POSTS) {
        state.data.POSTS = {}
      }
      Vue.set(state.data.POSTS, payload.name, payload)
    },
    SET_LIGHTBOX(state, payload) {
      state.lightboxData = payload
    },
    ADD_DATA_TO_HOME(state, payload) {
      state.data[payload.type].data.home[payload.name] = payload.data
    },
    ADD_DATA_TO_PART(state, payload) {
      state.data[payload.type].data[payload.name] = payload.data
    },
    ADD_MODALS_TO_LOAD(state, payload) {
      state.data[payload.type].data.modals_to_load.push(...payload.data)
    },
    SET_LOADING(state, isLoading) {
      state.loading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_STORIES_WITH_TOTAL(state, { data, total, cacheKey }) {
      state.storiesCache[cacheKey] = { data, total, cacheKey } // Store total in the cache object
      state.stories = data
      state.totalStories = total
      state.error = null
      state.loading = false
    },
    SET_TOTAL_STORIES(state, total) {
      state.totalStories = total
    },
    SET_CACHED_STORIES(state, cachedStories) {
      state.stories = cachedStories
      state.loading = false
      state.error = null
    },
    SET_SINGLE_STORY(state, story) {
      state.singleStory = story
      state.isSingleStoryRoute = true
      state.error = null
      state.loading = false
    },
    SET_IS_SINGLE_STORY_ROUTE(state, value) {
      state.isSingleStoryRoute = value
    },
    CLEAR_STORIES(state) {
      state.stories = []
      state.totalStories = 0
      state.error = null
      state.loading = false
    },
    CLEAR_SINGLE_STORY(state) {
      state.singleStory = null
      state.isSingleStoryRoute = false
      state.error = null
      state.loading = false
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    },
  },
  actions: {
    showModal({ commit }, modalName) {
      commit('TOGGLE', {
        type: 'modalOpen',
        status: modalName,
      })
    },
    hideModal({ commit }) {
      commit('TOGGLE', {
        type: 'modalOpen',
        status: false,
      })
    },
    setLightboxData({ commit }, payload) {
      commit('SET_LIGHTBOX', payload)
    },
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU')
    },
    toggleStatus({ commit }, payload) {
      const toggleCol = payload.status ? 'LimeGreen ' : 'IndianRed'
      console.log(
        '%c%s',
        `color: ${toggleCol};`,
        'toggelStatus ' + payload.type + ' to ' + payload.status
      )
      commit('TOGGLE', payload)
    },
    showMenuButtonAction({ commit }) {
      commit('TOGGLE', {
        type: 'menuButton',
        status: true,
      })
    },
    hideMenuButtonAction({ commit }) {
      console.log('hideMenuButtonAction')
      commit('TOGGLE', {
        type: 'menuButton',
        status: false,
      })
    },
    loadCoreData({ commit, state }, payload) {
      //dont load if exists in state
      if (state.data[payload.type]) {
        console.log('data already exists - ' + payload.type)
        commit('TOGGLE', {
          type: 'coreDataLoaded',
          status: true,
        })
      }
      //fetch the data
      else {
        console.log('loading new data - ' + payload.type)
        axios
          .get(axios.defaults.baseURL + payload.url)
          .then((response) => {
            console.log('%c%s', 'color: purple;', 'commiting base data: ' + payload.type)

            commit('SET_DATA', {
              type: payload.type,
              data: response.data,
              error: false,
              loaded: true,
            })

            if (response.data.home.modals_to_load) {
              console.log('%c%s', 'color: purple;', 'has modals to load')

              return response.data.home.modals_to_load
            }

            return false
          })
          .then((response) => {
            if (response) {
              console.log('%c%s', 'color: purple;', 'loading modals')

              let modals = response.map((modal) =>
                axios.get(axios.defaults.baseURL + `/modals/${modal}.json`)
              )

              return axios.all(modals).then((res) => {
                return res.map((modal) => modal.data)
              })
            }

            console.log('%c%s', 'color: purple;', 'no modals to load')

            return false
          })
          .then((response) => {
            if (response) {
              console.log('%c%s', 'color: purple;', 'committing modals to outline')

              commit('ADD_DATA_TO_HOME', {
                type: payload.type,
                data: response,
                name: 'modals',
                error: false,
                loaded: true,
              })
            }

            //is this core data for the app?
            commit('TOGGLE', {
              type: 'coreDataLoaded',
              status: true,
            })
          })
          .catch((error) => {
            commit('SET_DATA', {
              type: payload.type,
              data: false,
              error: error,
              loaded: true,
            })
            commit('TOGGLE', {
              type: 'coreDataLoaded',
              status: true,
            })
          })
      }
    },
    loadPartData({ commit, state }, payload) {
      //slide or timeline for use later
      let type = false

      //dont load if exists in state
      if (state.data[payload.type]) {
        console.log('%c%s', 'color: orange;', 'data already exists - ' + payload.type)

        commit('TOGGLE', {
          type: 'viewDataLoaded',
          status: true,
        })
      }
      //fetch the data
      else {
        console.log('%c%s', 'color: orange;', 'fetching data - ' + payload.type)
        axios
          .get(axios.defaults.baseURL + payload.url)
          .then((response) => {
            console.log('%c%s', 'color: orange;', 'commiting base data: ' + payload.type)

            commit('SET_DATA', {
              type: payload.type,
              data: response.data,
              error: false,
              loaded: true,
            })

            return response.data
          })
          .then((response) => {
            console.log('%c%s', 'color: orange;', 'checking part data for sliders and timelines')

            if (response.components.sliders) {
              type = 'sliders'
              console.log(type)
              console.log('%c%s', 'color: orange;', 'slider found, fetching data')
              return axios
                .get(axios.defaults.baseURL + `/sliders/${response.components.sliders}.json`)
                .then((res) => {
                  return res.data
                })
            } else if (response.components.timelines) {
              type = 'timelines'
              console.log(type)
              console.log('%c%s', 'color: orange;', 'timeline found, fetching data')
              return axios
                .get(axios.defaults.baseURL + `/timelines/${response.components.timelines}.json`)
                .then((res) => {
                  return res.data
                })
            }

            console.log('%c%s', 'color: orange;', 'no slider or timeline found')
            return false
          })
          .then((response) => {
            if (response) {
              console.log('%c%s', 'color: orange;', 'commiting ' + type + ' data to state')

              commit('ADD_DATA_TO_PART', {
                type: payload.type,
                data: response,
                name: type,
                error: false,
                loaded: true,
              })

              if (response.modals_to_load) {
                console.log(
                  '%c%s',
                  'color: orange;',
                  type + ' has modals, committing to modals to load'
                )
                commit('ADD_MODALS_TO_LOAD', {
                  type: payload.type,
                  data: response.modals_to_load,
                  error: false,
                  loaded: true,
                })
              }
            }

            let state_modals_to_load = state.data[payload.type].data.modals_to_load
            if (state_modals_to_load.length) {
              console.log('%c%s', 'color: orange;', 'models to load', state_modals_to_load)
              return state_modals_to_load
            }

            return false
          })
          .then((response) => {
            if (response) {
              console.log('%c%s', 'color: orange;', 'loading modals')

              let modals = response.map((modal) =>
                axios.get(axios.defaults.baseURL + `/modals/${modal}.json`)
              )

              return axios.all(modals).then((res) => {
                return res.map((modal) => modal.data)
              })
            }

            console.log('%c%s', 'color: orange;', 'no modals to load')

            return false
          })
          .then((response) => {
            if (response) {
              console.log('%c%s', 'color: orange;', 'committing modals to part')

              commit('ADD_DATA_TO_PART', {
                type: payload.type,
                data: response,
                name: 'modals',
                error: false,
                loaded: true,
              })
            }

            console.log('%c%s', 'color: orange;', 'toggle state viewDataLoaded')
            //is this core data for the app?

            commit('TOGGLE', {
              type: 'viewDataLoaded',
              status: true,
            })
          })
          .catch((error) => {
            commit('SET_DATA', {
              type: payload.type,
              data: false,
              error: error,
              loaded: true,
            })
            commit('TOGGLE', {
              type: 'viewDataLoaded',
              status: true,
            })
          })
      }
    },
    getPostsData({ commit, state }, payload) {
      //check if exist
      if (state.data.POSTS[payload.name]) {
        console.log('posts data already exists for ' + payload.name)

        return
      }

      //get the data and commit
      else {
        let ids = payload.ids.toString()
        let number = payload.number ? payload.number : 6
        let params = {}

        if (payload.type == 'ids' || !payload.type) {
          params.include = ids
          payload.number = payload.ids.length
        } else if (payload.type == 'categories') {
          params.categories = ids
        } else if (payload.type == 'tags') {
          params.tags = ids
        } else {
          return false
        }

        params.per_page = number

        console.log('loading new posts for ' + payload.name)
        axios
          .get('https://blog.londolozi.com/wp-json/wp/v2/posts/', {
            params: params,
          })
          .then((response) => {
            let postData = response.data.map((post) => {
              return {
                id: post.id,
                name: post.name,
                author_name: post.author_name,
                author_picture: post.author_picture,
                thumbnail: post.thumbnail,
                date_formatted: post.date_formatted,
                link: post.link,
              }
            })

            if (response.data.length > 0) {
              commit('SET_POSTS', {
                name: payload.name,
                data: postData,
                error: false,
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    async getStoriesData({ commit, state }, { page = 1, category = null }) {
      const cacheKey = `page-${page}${category ? `-category-${category}` : ''}`

      if (state.storiesCache[cacheKey]) {
        console.log(`Retrieving stories from cache for: ${cacheKey}`)
        commit('SET_LOADING', true)
        commit('SET_CACHED_STORIES', state.storiesCache[cacheKey].data)
        commit('SET_CURRENT_PAGE', page)

        const cachedTotalEntry = Object.values(state.storiesCache).find((cached) => {
          if (cached && cached.cacheKey) {
            const cachedCategory = cached.cacheKey.includes('-category-')
              ? cached.cacheKey.split('-category-')[1]
              : null
            return cachedCategory === category
          }
          return false
        })

        if (cachedTotalEntry && cachedTotalEntry.total !== undefined) {
          commit('SET_TOTAL_STORIES', cachedTotalEntry.total)
        }
        commit('SET_LOADING', false)
        return
      }

      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      commit('SET_CURRENT_PAGE', page)

      let apiUrl = 'https://africa.londolozi.com/wp-json/wp/v2/posts/'
      let params = {
        per_page: state.storiesPerPage,
        page: page,
        _embed: 'wp:term',
      }

      if (category) {
        try {
          const categoryResponse = await axios.get(
            `https://africa.londolozi.com/wp-json/wp/v2/categories?slug=${category}`
          )
          if (categoryResponse.data && categoryResponse.data.length > 0) {
            params.categories = categoryResponse.data[0].id
          } else {
            // If category not found, this is an error for story fetching
            commit('SET_ERROR', 'Category not found')
            commit('SET_LOADING', false)
            commit('CLEAR_STORIES')
            return Promise.reject(new Error('Category not found'))
          }
        } catch (error) {
          console.error('Error fetching category:', error)
          commit('SET_ERROR', 'Error fetching category')
          commit('SET_LOADING', false)
          return Promise.reject(error)
        }
      }

      console.log('Fetching data from:', apiUrl, 'with params:', params)

      try {
        const response = await axios.get(apiUrl, { params })

        const storiesData = response.data
        const totalPosts = parseInt(response.headers['x-wp-total']) || 0

        if (storiesData.length === 0 && totalPosts === 0 && page === 1) {
          commit('SET_ERROR', 'No stories found for this query.')
          commit('CLEAR_STORIES') // Clear existing stories
          commit('SET_LOADING', false)
          return Promise.reject(new Error('No stories found.'))
        }

        // Store both data and total in the cache
        commit('SET_STORIES_WITH_TOTAL', { data: storiesData, total: totalPosts, cacheKey })
        commit('SET_LOADING', false)
        return storiesData
      } catch (error) {
        console.error('Error fetching stories:', error)
        commit('SET_ERROR', 'Failed to fetch stories.')
        commit('SET_LOADING', false)
        return Promise.reject(error)
      }
    },

    async getSingleStory({ commit, state }, slug) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      // First, check if the story is present in any of the cached lists
      for (const key in state.storiesCache) {
        const cachedItem = state.storiesCache[key]
        if (cachedItem && Array.isArray(cachedItem.data)) {
          const foundStory = cachedItem.data.find((story) => story.slug === slug)
          if (foundStory) {
            console.log(`Retrieving single story from list cache for slug: ${slug}`)
            commit('SET_SINGLE_STORY', foundStory)
            commit('SET_LOADING', false)
            return foundStory // Return the found story for consistency, though not strictly required if only rejection matters
          }
        }
      }

      // If not found in the list cache, make an API call
      try {
        const response = await axios.get(
          `https://africa.londolozi.com/wp-json/wp/v2/posts?_embed=wp:term&slug=${slug}`
        )

        if (response.data && response.data.length > 0) {
          commit('SET_SINGLE_STORY', response.data[0])
          commit('SET_LOADING', false)
          return response.data[0] // Return the found story data
        } else {
          // If story not found by API, reject the promise
          commit('SET_ERROR', 'Post not found.')
          commit('SET_IS_SINGLE_STORY_ROUTE', false)
          commit('SET_LOADING', false)
          return Promise.reject(new Error('Single story not found.')) // <-- CRUCIAL: Reject here
        }
      } catch (error) {
        console.error('Error fetching single story:', error)
        commit('SET_ERROR', 'Failed to fetch the post.')
        commit('SET_LOADING', false)
        commit('SET_IS_SINGLE_STORY_ROUTE', false)
        return Promise.reject(error)
      }
    },
  },
})
